import './assets/styles/reset.scss'
import './assets/styles/main.scss'

import { createApp } from 'vue'
import App from './App.vue'


createApp(App).mount('#app')
